
export enum ERole {
    SYSTEM = "system",
    ASSISTANT = "assistant",
    USER = "user",
}

export interface IMessage {
    src?: string, 
    role: string,
    content: string, 
}

export interface IcmpChatBot {
    user: IMessage,
    bot: IMessage,

}

export interface ICard {
    card: any
}